import { Injectable } from '@angular/core';
import { HistoricService } from '../services/historic.service';
import { Apollo } from 'apollo-angular';
import { GET_ALL, GET_MOVIL } from '../graphql/mobile';
import { MOTIVES } from '../graphql/motive';
import { GET_TEAMS } from '../graphql/team';
// import * as XLSX from 'xlsx';
import moment from 'moment';

import { Subject, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  subject: Subject<any> = new Subject<any>();
  observable: Observable<any> = this.subject.asObservable();
  dataForArrayList: Subject<any> = new Subject<any>();
  observableArray: Observable<any> = this.dataForArrayList.asObservable();

  subjectImage: Subject<any> = new Subject<any>();
  observableImage: Observable<any> = this.subjectImage.asObservable();

  constructor(public _historic: HistoricService,
    private apollo: Apollo) { }

  locationOff = '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"width="35" height="35"viewBox="0 0 172 172"style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none" stroke="none"></path><g stroke="none"><path d="M86,90.65475l-17.4752,17.4752l-4.65475,-4.65475l17.4752,-17.4752l-17.20215,-17.20215l4.65475,-4.65475l17.20215,17.20215l17.4752,-17.4752l4.65475,4.65475l-17.4752,17.4752l17.4752,17.4752l-4.65475,4.65475z" fill="#f78f8f"></path><path d="M103.4752,65.3901l3.1347,3.1347l-15.95515,15.95515l-1.52005,1.52005l1.52005,1.52005l15.95515,15.95515l-3.1347,3.1347l-15.95515,-15.95515l-1.52005,-1.52005l-1.52005,1.52005l-15.95515,15.95515l-3.1347,-3.1347l15.95515,-15.95515l1.52005,-1.52005l-1.52005,-1.52005l-15.6821,-15.6821l3.1347,-3.1347l15.6821,15.6821l1.52005,1.52005l1.52005,-1.52005l15.95515,-15.95515M103.4752,62.35l-17.4752,17.4752l-17.20215,-17.20215l-6.1748,6.1748l17.20215,17.20215l-17.4752,17.4752l6.1748,6.1748l17.4752,-17.4752l17.4752,17.4752l6.1748,-6.1748l-17.4752,-17.4752l17.4752,-17.4752l-6.1748,-6.1748z" fill="#c74343"></path><path d="M86,153.725c-37.34335,0 -67.725,-30.38165 -67.725,-67.725c0,-37.34335 30.38165,-67.725 67.725,-67.725c37.34335,0 67.725,30.38165 67.725,67.725c0,37.34335 -30.38165,67.725 -67.725,67.725zM86,37.625c-26.67505,0 -48.375,21.69995 -48.375,48.375c0,26.67505 21.69995,48.375 48.375,48.375c26.67505,0 48.375,-21.69995 48.375,-48.375c0,-26.67505 -21.69995,-48.375 -48.375,-48.375z" fill="#c2e8ff"></path><path d="M86,19.35c36.74995,0 66.65,29.90005 66.65,66.65c0,36.74995 -29.90005,66.65 -66.65,66.65c-36.74995,0 -66.65,-29.90005 -66.65,-66.65c0,-36.74995 29.90005,-66.65 66.65,-66.65M86,135.45c27.2663,0 49.45,-22.1837 49.45,-49.45c0,-27.2663 -22.1837,-49.45 -49.45,-49.45c-27.2663,0 -49.45,22.1837 -49.45,49.45c0,27.2663 22.1837,49.45 49.45,49.45M86,17.2c-37.99695,0 -68.8,30.80305 -68.8,68.8c0,37.99695 30.80305,68.8 68.8,68.8c37.99695,0 68.8,-30.80305 68.8,-68.8c0,-37.99695 -30.80305,-68.8 -68.8,-68.8zM86,133.3c-26.1225,0 -47.3,-21.1775 -47.3,-47.3c0,-26.1225 21.1775,-47.3 47.3,-47.3c26.1225,0 47.3,21.1775 47.3,47.3c0,26.1225 -21.1775,47.3 -47.3,47.3z" fill="#7496c4"></path><path d="M82.775,5.375h6.45v32.25h-6.45z" fill="#8bb7f0"></path><path d="M88.15,6.45v30.1h-4.3v-30.1h4.3M90.3,4.3h-8.6v34.4h8.6v-34.4z" fill="#4e7ab5"></path><g><path d="M134.375,82.775h32.25v6.45h-32.25z" fill="#8bb7f0"></path><path d="M165.55,83.85v4.3h-30.1v-4.3h30.1M167.7,81.7h-34.4v8.6h34.4v-8.6z" fill="#4e7ab5"></path></g><g><path d="M5.375,82.775h32.25v6.45h-32.25z" fill="#8bb7f0"></path><path d="M36.55,83.85v4.3h-30.1v-4.3h30.1M38.7,81.7h-34.4v8.6h34.4v-8.6z" fill="#4e7ab5"></path></g><g><path d="M82.775,134.375h6.45v32.25h-6.45z" fill="#8bb7f0"></path><path d="M88.15,135.45v30.1h-4.3v-30.1h4.3M90.3,133.3h-8.6v34.4h8.6v-34.4z" fill="#4e7ab5"></path></g></g><g stroke="none"><g id="Layer_1"><g><circle cx="40.17912" cy="39.63904" transform="scale(2.15,2.15)" r="17.5" fill="#f78f8f"></circle><g fill="#c74343"><path d="M86.38511,48.67394c20.21,0 36.55,16.34 36.55,36.55c0,20.21 -16.34,36.55 -36.55,36.55c-20.21,0 -36.55,-16.34 -36.55,-36.55c0,-20.21 16.34,-36.55 36.55,-36.55M86.38511,46.52394c-21.285,0 -38.7,17.415 -38.7,38.7c0,21.285 17.415,38.7 38.7,38.7c21.285,0 38.7,-17.415 38.7,-38.7c0,-21.285 -17.415,-38.7 -38.7,-38.7z"></path></g></g><rect x="-9.51824" y="54.44037" transform="rotate(-45) scale(2.14998,2.14998)" width="19.8" height="4" fill="#ffffff"></rect><rect x="-1.61824" y="46.54037" transform="rotate(-45) scale(2.14998,2.14998)" width="4" height="19.8" fill="#ffffff"></rect></g></g><path d="M47.68511,123.92394v-77.4h77.4v77.4z" id="overlay-drag" fill="#ff0000" stroke="none" opacity="0"></path></g></svg>';
  locationOn = '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"width="35" height="35"viewBox="0 0 172 172"style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none" stroke="none"></path><g stroke="none"><path d="M86,90.65475l-17.4752,17.4752l-4.65475,-4.65475l17.4752,-17.4752l-17.20215,-17.20215l4.65475,-4.65475l17.20215,17.20215l17.4752,-17.4752l4.65475,4.65475l-17.4752,17.4752l17.4752,17.4752l-4.65475,4.65475z" fill="#f78f8f"></path><path d="M103.4752,65.3901l3.1347,3.1347l-15.95515,15.95515l-1.52005,1.52005l1.52005,1.52005l15.95515,15.95515l-3.1347,3.1347l-15.95515,-15.95515l-1.52005,-1.52005l-1.52005,1.52005l-15.95515,15.95515l-3.1347,-3.1347l15.95515,-15.95515l1.52005,-1.52005l-1.52005,-1.52005l-15.6821,-15.6821l3.1347,-3.1347l15.6821,15.6821l1.52005,1.52005l1.52005,-1.52005l15.95515,-15.95515M103.4752,62.35l-17.4752,17.4752l-17.20215,-17.20215l-6.1748,6.1748l17.20215,17.20215l-17.4752,17.4752l6.1748,6.1748l17.4752,-17.4752l17.4752,17.4752l6.1748,-6.1748l-17.4752,-17.4752l17.4752,-17.4752l-6.1748,-6.1748z" fill="#c74343"></path><path d="M86,153.725c-37.34335,0 -67.725,-30.38165 -67.725,-67.725c0,-37.34335 30.38165,-67.725 67.725,-67.725c37.34335,0 67.725,30.38165 67.725,67.725c0,37.34335 -30.38165,67.725 -67.725,67.725zM86,37.625c-26.67505,0 -48.375,21.69995 -48.375,48.375c0,26.67505 21.69995,48.375 48.375,48.375c26.67505,0 48.375,-21.69995 48.375,-48.375c0,-26.67505 -21.69995,-48.375 -48.375,-48.375z" fill="#c2e8ff"></path><path d="M86,19.35c36.74995,0 66.65,29.90005 66.65,66.65c0,36.74995 -29.90005,66.65 -66.65,66.65c-36.74995,0 -66.65,-29.90005 -66.65,-66.65c0,-36.74995 29.90005,-66.65 66.65,-66.65M86,135.45c27.2663,0 49.45,-22.1837 49.45,-49.45c0,-27.2663 -22.1837,-49.45 -49.45,-49.45c-27.2663,0 -49.45,22.1837 -49.45,49.45c0,27.2663 22.1837,49.45 49.45,49.45M86,17.2c-37.99695,0 -68.8,30.80305 -68.8,68.8c0,37.99695 30.80305,68.8 68.8,68.8c37.99695,0 68.8,-30.80305 68.8,-68.8c0,-37.99695 -30.80305,-68.8 -68.8,-68.8zM86,133.3c-26.1225,0 -47.3,-21.1775 -47.3,-47.3c0,-26.1225 21.1775,-47.3 47.3,-47.3c26.1225,0 47.3,21.1775 47.3,47.3c0,26.1225 -21.1775,47.3 -47.3,47.3z" fill="#7496c4"></path><path d="M82.775,5.375h6.45v32.25h-6.45z" fill="#8bb7f0"></path><path d="M88.15,6.45v30.1h-4.3v-30.1h4.3M90.3,4.3h-8.6v34.4h8.6v-34.4z" fill="#4e7ab5"></path><g><path d="M134.375,82.775h32.25v6.45h-32.25z" fill="#8bb7f0"></path><path d="M165.55,83.85v4.3h-30.1v-4.3h30.1M167.7,81.7h-34.4v8.6h34.4v-8.6z" fill="#4e7ab5"></path></g><g><path d="M5.375,82.775h32.25v6.45h-32.25z" fill="#8bb7f0"></path><path d="M36.55,83.85v4.3h-30.1v-4.3h30.1M38.7,81.7h-34.4v8.6h34.4v-8.6z" fill="#4e7ab5"></path></g><g><path d="M82.775,134.375h6.45v32.25h-6.45z" fill="#8bb7f0"></path><path d="M88.15,135.45v30.1h-4.3v-30.1h4.3M90.3,133.3h-8.6v34.4h8.6v-34.4z" fill="#4e7ab5"></path></g></g><g stroke="none"><g id="Layer_1"><g><circle cx="40.17912" cy="39.63904" transform="scale(2.15,2.15)" r="17.5" fill="#bae0bd"></circle><g fill="#5e9c76"><path d="M86.38511,48.67394c20.21,0 36.55,16.34 36.55,36.55c0,20.21 -16.34,36.55 -36.55,36.55c-20.21,0 -36.55,-16.34 -36.55,-36.55c0,-20.21 16.34,-36.55 36.55,-36.55M86.38511,46.52394c-21.285,0 -38.7,17.415 -38.7,38.7c0,21.285 17.415,38.7 38.7,38.7c21.285,0 38.7,-17.415 38.7,-38.7c0,-21.285 -17.415,-38.7 -38.7,-38.7z"></path></g></g><path d="M83.16011,103.28394l-16.985,-16.985l6.02,-6.02l10.965,10.965l19.565,-19.565l6.02,6.02z" fill="#ffffff"></path></g></g><path d="M47.68511,123.92394v-77.4h77.4v77.4z" id="overlay-drag" fill="#ff0000" stroke="none" opacity="0"></path></g></svg>'



  dateTimeStamp(date: string) {
    return new Date(date).getTime()
  }


  location_Batery(battery, gps) {

    const bat = battery;
    var newData = {
      batterySend: "",
      location: ""
    }




    if (bat >= 70 && bat < 100) {
      newData.batterySend = '<i style= "color : #33FF58;"class="fas fa-battery-three-quarters fa-lg"></i>'

    } else if (bat < 70 && bat >= 50) {


      newData.batterySend = '<i style= "color : #FFB551;"class="fas fa-battery-half fa-lg"></i>'

    } else if (bat < 50) {
      newData.batterySend = '<i style= "color : #FF3333;"class="fas fa-battery-quarter fa-lg"></i>'
    } else if (bat >= 100) {
      newData.batterySend = '<i style= "color : #33FF58;"class="fas fa-battery-full fa-lg"></i>'

    }
    if (gps == true) {
      newData.location = this.locationOn;

    } else {

      newData.location = this.locationOff;
    }

    return newData;

  }

  sortAlph = (array, key) => {
    return array.sort((a, b) => {
      var x = a[key].toUpperCase(); var y = b[key].toUpperCase();
      return (x < y) ? -1 : (x > y) ? 1 : 0;
    });
  }


  infowindow(params) {

    var newData = this.location_Batery(params.battery, params.gps);



    // var statusType = 




    var contentString =
      '<div style="height: 215px; width: 200px;font-family: Poppins, sans-serif;" class="animated zoomIn">' +
      ' <div style="padding: 5px;"> ' +
      '<div style="height: 43px; border-radius:20px;   background: whitesmoke; font-size: 14px; display: flex; justify-content: center; align-items: center">' +
      params.userId +
      '</div> ' +
      '</div>' +
      ' <div style="padding: 5px;"> ' +
      '<div style=" border-radius:20px; height: 43px;background: whitesmoke; font-size: 14px; display: flex; justify-content: center; align-items: center">' +
      params.address +
      '</div> ' +

      '</div>' +

      ' <div style="padding: 5px;"> ' +
      '<div style="height: 43px; border-radius:20px; background: whitesmoke; font-size: 14px; display: flex; justify-content: center; align-items: center">' +
      '</div> ' +

      '</div>' +

      ' <div style=" padding: 5px; display: flex;"> ' +
      '<div style=" height:  43px; width: 50%; background: whitesmoke; font-size: 14px; display: flex; justify-content: center; align-items: center">' +
      ' <div>  ' + newData.batterySend + '</div>' +
      ' <div style ="padding-left: 10px;"> ' + params.battery + ' %</div> ' +

      '</div> ' +

      '<div style="height: 43px; width: 50%; background: whitesmoke; font-size: 14px; display: flex; justify-content: center; align-items: center">' +
      newData.location +
      '</div> ' +

      '</div>' +

      '</div>'
      ;

    return contentString
  }



  // substractOneHour(date): any {
  //   return moment(new Date(date)).subtract(1, 'hour').format("YYYY-MM-DD HH:mm:ss");
  // }

  // substractOneDay(date): any {
  //   return moment(new Date(date)).subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss");
  // }


  renderPlateOrAlias(plate: string, alias: string): string {
    if (plate != null && plate != "") {
      if (this.testContainsNumber(plate)) {
        if (alias.length > 8) {
          return alias.slice(0, 8);
        }
        else {
          return alias;
        }
      } else {
        if (plate.length > 8) {
          return plate.slice(0, 9) + "...";
        }
        else {
          return plate;
        }
      }
    } else {
      if (alias != null && alias != "") {
        if (alias.length > 8) {
          return alias.slice(0, 8);
        }
        else {
          return alias;
        }
      } else {
        return "";
      }
    }
  }

  public getAllDevices(variables: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apollo.watchQuery({
        query: GET_ALL,
        variables: variables
      }).valueChanges.subscribe(
        resp => {
          resolve(resp);
        },
        err => {
          reject(err);
        });
    })
  }

  public getAllMotives(): Promise<any> {
    return new Promise((resolve) => {
      this.apollo.watchQuery({
        query: MOTIVES
      }).valueChanges.subscribe(res => {
        resolve(res);
      }, err => {
        throw err;
      })
    })
  }

  public getAllTeams(company: any): Promise<any> {
    return new Promise((resolve) => {
      this.apollo.watchQuery({
        query: GET_TEAMS,
        variables: {
          GrEmpresa: company
        }
      }).valueChanges.subscribe(res => {
        resolve(res);
      }, err => {
        throw err;
      });
    })
  }

  getMovil(id: string): Promise<any> {
    return new Promise((resolve) => {
      this.apollo.watchQuery({
        query: GET_MOVIL,
        variables: {
          Id: id
        }
      }).valueChanges.subscribe(res => {
        resolve(res);
      }, err => {
        throw err;
      })
    })
  }

  testContainsNumber(value: string) {
    return /[0-9]/gm.test(value);
  }

  getDateNow(): any {
    return moment().format('YYYY-MM-DD HH:mm:ss');
  }

  parseDate(date): any {
    return moment(new Date(date)).format('YYYY-MM-DD HH:mm:ss');
  }

  parseNewDateFormat(date): any {
    return moment(date, 'ddd YYYY-MM-DDhh:mm:ss A').format('YYYY-MM-DD hh:mm:ss A');
  }

  parseFormatRecording(date): any {
    return moment(new Date(date)).format('YYYY-MM-DD hh:mm:ss A');
  }

  parseDateForJasper(date): any {
    return moment(new Date(date)).format('YYYY-MM-DDTHH:mm:ss');
  }

  validateIsAfter(firstDate, secondDate): any {
    return moment(firstDate).isAfter(secondDate);
  }

  parseCoordinate(coordinate) {
    return parseFloat(coordinate);
  }

  timeDifferenceForDate(date: string) {
    var _date: any = new Date(date);
    var userTimezoneOffset = _date.getTimezoneOffset() * 60000;
    var newDate: any = new Date(_date.getTime() + userTimezoneOffset).toUTCString();
    // return moment(new Date(newDate)).format('YYYY-MM-DD HH:mm:ss');
  }

  momentUtc(date: string) {
    return moment.utc(date).format();
  }

  dateImg() {
    let dat = new Date();
    var date = '' + dat.getFullYear() + ((dat.getMonth() < 9) ? '0' + (dat.getMonth() + 1) : (dat.getMonth() + 1)) + ((dat.getDate() < 10) ? '0' + (dat.getDate()) : (dat.getDate())) + '' + ((dat.getHours() < 10) ? '0' + (dat.getHours()) : (dat.getHours())) + ((dat.getMinutes() < 10) ? '0' + (dat.getMinutes()) : (dat.getMinutes())) + ((dat.getSeconds() < 10) ? '0' + (dat.getSeconds()) : (dat.getSeconds())) + ((dat.getMilliseconds() < 10) ? '0' + (dat.getMilliseconds()) : (dat.getMilliseconds()));
    return date;
  }


  getUserPosition(): Promise<any>
  {
    return new Promise((resolve, reject) => {

      navigator.geolocation.watchPosition(resp => {
          resolve(resp);
        },
        err => {
          reject(err);
        });
    });

  }


  makeObject(array: any[], key: string, value: string): Promise<any> {
    let obj = {};
    return new Promise((resolve) => {
      array.map(item => {
        obj[item[key]] = item[value];
      });
      resolve(obj);
    });
  }

  isEmpty(obj) {
    console.log("obj", obj);
    for (let key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }

    return true;
  }

  setDevices(devices: any, company: number) {
    let allDevices = devices;
    let newItem;

    let finalDevices = [];
    allDevices.map((item) => {
      newItem = {
        Id: item.Id,
        Placa: item.Placa,
        Alias: item.Alias,
        Grupo: item.GrupoNombre,
        GrupoId: item.Grupo
      };
      if (company != 968) {

        if (item.Alias != null && item.Alias != "" && item.Alias != " ") {
          if (item.Placa != null && item.Placa != "" && item.Placa != " ") {
            if (item.Alias.toUpperCase() == item.Placa.toUpperCase()) {
              newItem.renderPlate = item.Placa.toUpperCase();
              newItem.Placa = "";
            } else {
              if (!this.testContainsNumber(item.Placa)) {
                newItem.renderPlate = item.Placa.toUpperCase() + " " + item.Alias.toUpperCase();
                newItem.Placa = "";
              } else {
                newItem.renderPlate = item.Alias.toUpperCase();
                newItem.Placa = item.Placa;
              }
            }
          } else {
            newItem.renderPlate = "";
            newItem.Placa = "";
          }
        } else {
          newItem.renderPlate = item.Placa.toUpperCase();
          newItem.Placa = "";
        }
      } else {
        if (item.Alias != null) {
          newItem.renderPlate = item.Alias;
        } else {
          newItem.renderPlate = item.Placa;
        }
      }

      if (item.Placa == null) {
        newItem.renderPlate = item.Alias;
      } else {
        newItem.renderPlate = item.Placa;

      }
      finalDevices.push(newItem);

    });
    return finalDevices;
  }

  setGps(data) {
    if (data == 1 || data == true) {
      return true;
    }
    else if (data == 0 || data == '0' || data == false) {
      return false;
    }
  }

  setRumbo(data) {

    if (data != "" && data !== undefined && data !== null) {
      data = parseInt(data);
      if ((data >= 339 && data < 361) || (data >= 0 && data <= 23)) {
        return "N";
      } else if (data >= 24 && data <= 68) {
        return "NE";
      } else if (data >= 69 && data <= 113) {
        return "E";
      } else if (data >= 114 && data <= 158) {
        return "SE";
      } else if (data >= 159 && data <= 203) {
        return "S";
      } else if (data >= 204 && data <= 248) {
        return "SO";
      } else if (data >= 249 && data <= 293) {
        return "O";
      } else if (data >= 294 && data <= 338) {
        return "NO";
      }

    }
    else {
      return "";
    }
  }

  setBatery(data) {
    if (data != "" && data !== undefined && data !== null) {
      return data + " %";
    }
    else {
      return "N/A";
    }
  }

  // public readArchive(file): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     let fileReader = new FileReader();
  //     fileReader.onloadend = (e) => {
  //       let arrayBuffer: any = fileReader.result;
  //       var data = new Uint8Array(arrayBuffer);
  //       var arr = new Array();
  //       for (var i = 0; i < data.length; i++) arr[i] = String.fromCharCode(data[i]);
  //       var bstr = arr.join("");
  //       var workbook = XLSX.read(bstr, { type: "binary" });
  //       var first_sheet_name = workbook.SheetNames[0];
  //       var worksheet = workbook.Sheets[first_sheet_name];
  //       let finalData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
  //       resolve(finalData)
  //     }
  //     fileReader.readAsArrayBuffer(file);
  //   });
  // }

}
